import { render, staticRenderFns } from "./MemoTagEditDialog.vue?vue&type=template&id=74572dc7&scoped=true"
import script from "./MemoTagEditDialog.vue?vue&type=script&lang=ts"
export * from "./MemoTagEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./MemoTagEditDialog.vue?vue&type=style&index=0&id=74572dc7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74572dc7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74572dc7')) {
      api.createRecord('74572dc7', component.options)
    } else {
      api.reload('74572dc7', component.options)
    }
    module.hot.accept("./MemoTagEditDialog.vue?vue&type=template&id=74572dc7&scoped=true", function () {
      api.rerender('74572dc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/MemoTagEditDialog.vue"
export default component.exports